import React, { Component } from 'react';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';
import R from 'ramda';

import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import {
  getMemberByUserId,
  getWorkTypeNameById,
  getAgreementDiscountedCost,
} from '../../utils';

class AgreementPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      instance: null,
      payLoading: false,
      total: 0,
    };
  }

  componentWillMount() {
    const { profile } = this.props;

    this.props.getClientToken();
    const total = getAgreementDiscountedCost(profile.referrer);
    this.setState({ total: total.toFixed(2) });
  }

  componentWillReceiveProps(nextProps) {
    const {
      paymentStatus,
      status,
      agreement,
      dealStatus,
      deal,
      workStatus,
      work,
    } = nextProps;

    if (paymentStatus !== this.props.paymentStatus) {
      if (paymentStatus === actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
        this.createAgreement();
      } else if (paymentStatus === actionTypes.PAYMENT_TRANSACTION_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Payment failed. Please try again');
      }
    }

    if (this.props.status === actionTypes.AGREEMENT_CREATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_CREATE_SUCCESS && agreement) {
        this.saveContractBlocks(agreement);
        this.createWork(agreement.id);
      } else if (status === actionTypes.AGREEMENT_CREATE_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (this.props.workStatus === actionTypes.WORK_CREATE_REQUEST) {
      if (workStatus === actionTypes.WORK_CREATE_SUCCESS && work && agreement) {
        this.createDeal(agreement, work);
        this.createWorkOwnerships(work);
      } else if (workStatus === actionTypes.WORK_CREATE_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (this.props.dealStatus === actionTypes.DEAL_CREATE_REQUEST) {
      if (dealStatus === actionTypes.DEAL_CREATE_SUCCESS && deal) {
        this.createInvites(deal);
        this.setState({ payLoading: false }, () => {
          this.props.alert('success', 'Your agreement has been sent!');
          this.props.router.push('/');
        });
      } else if (dealStatus === actionTypes.DEAL_CREATE_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { clientToken } = this.props;
    const { instance } = this.state;

    if (clientToken && !instance) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container',
          translations: {
            chooseAWayToPay: 'Choose a payment option below:',
          },
        },
        (err, instance) => {
          if (!err) {
            this.setState({ instance });
          }
        }
      );
    }
  }

  createAgreement() {
    const { agreement, contractBlocks, fields } = this.props;
    if (agreement && agreement.id) {
      this.createWork(agreement.id, true);
    } else {
      let comments = fields.teamMessage;
      let licenserIds = [];
      const block = R.find(R.propEq('name', 'Licensing Permissions'))(
        contractBlocks
      );

      if (block && block.options) {
        licenserIds = block.options.licenserIds || [];
      }

      this.props.createAgreement({
        ...agreement,
        licenser_ids: licenserIds,
        comments,
      });
    }
  }

  createWork(agreementId) {
    const { fields, profile, team } = this.props;

    const data = {
      name: fields.name,
      type: fields.type,
      sub_type: fields.subtype,
      user: profile.id,
      agreement: agreementId,
      team: team.id,
      additional: true,
    };

    this.props.createWork(data);
  }

  saveContractBlocks(agreement) {
    const { agreementContractBlocks } = this.props;

    agreementContractBlocks.forEach((block) => {
      this.props.saveBlockContent({
        ...block,
        agreement: agreement.id,
      });
    });
  }

  createDeal(agreement, work) {
    const { team, profile } = this.props;

    const data = {
      team: team.id,
      user: profile.id,
      agreement: agreement.id,
      work: work.id,
    };

    this.props.createDeal(data);
  }

  createWorkOwnerships(work) {
    const { workOwnerships, members } = this.props;

    workOwnerships.forEach((ownership) => {
      let data = {
        work: work.id,
        ...ownership,
      };

      const member = getMemberByUserId(ownership.user, members);
      if (member && member.user_info) {
        data = {
          ...data,
          use_company_name: member.user_info.use_company_name,
          company_name: member.user_info.company_name,
          user_title: member.user_info.user_title,
          ...member.user_info,
        };
      }

      this.props.createWorkOwnership(data);
    });
  }

  getPubishable() {
    const { workTypes, fields, agreement } = this.props;

    if (
      agreement &&
      agreement.type !== 'workforhire' &&
      agreement.type !== 'producer'
    ) {
      if (fields.type) {
        const workTypeName = getWorkTypeNameById(fields.type, workTypes);
        return workTypeName === 'Music';
      }
    }

    return false;
  }

  createInvites(deal) {
    const { members, profile, fields } = this.props;

    const data = {
      deal: deal.id,
      inviter: profile.id,
      inviter_name: profile.name,
      type: 'member',
      comment: fields.teamMessage,
    };

    let inviteData = [];
    members.forEach((member) => {
      inviteData = [
        ...inviteData,
        {
          ...data,
          invitee: member.user,
          email: member.user_info.email,
          name: member.user_info.name,
        },
      ];
    });

    this.props.createInvite(deal.id, inviteData);

    this.props.createDealUser({
      deal: deal.id,
      user: profile.id,
      type: 'owner',
    });

    if (this.getPubishable()) {
      fields.memberPublishers &&
        fields.memberPublishers.forEach((member) => {
          if (member.publishers && member.publishers.length) {
            member.publishers.forEach(
              ({ publisherName, publisher_share, society }) => {
                if (publisherName || publisher_share || society) {
                  this.props.createPublisher({
                    deal: deal.id,
                    user: member.user,
                    publisher_name: publisherName,
                    publisher_share: parseFloat(publisher_share, 10) || 0,
                    society: society,
                  });
                }
              }
            );
          }
        });
    }

    this.props.resetCreateWork();
  }

  handlePayment = () => {
    const { instance, total } = this.state;

    // Process purchase and create transaction
    this.props.hideAlert();

    if (instance) {
      this.setState({ payLoading: true }, () => {
        this.props.alert(
          'info',
          'Payment is processing, please do not refresh page.'
        );
      });

      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          console.error(err);
          this.setState({ payLoading: false });
          this.props.alert('error', 'Payment creation failed.');
        } else {
          const data = {
            nonce: payload.nonce,
            amount: total.toString(),
            admin_fee_total: 0,
          };
          this.props.pay(data);
        }
      });
    }
  };

  handleNext() {
    const { agreementStartType } = this.props.fields;
    this.props.hideAlert();

    if (this.props.paymentStatus !== actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
      this.props.alert('error', 'Please make a valid payment.');
    } else {
      this.props.router.push(`/create/${agreementStartType}`);
    }
  }

  handlePrev() {
    const { agreementStartType } = this.props.fields;
    this.props.hideAlert();

    if (this.props.paymentStatus !== actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
      this.props.router.goBack();
    } else {
      this.props.router.push(`/create/${agreementStartType}`);
    }
  }

  renderCart() {
    const { total } = this.state;

    return (
      <div className="cart">
        <p>
          <strong>
            Please review your order below. If you leave this session without
            completing this step, your information will not be saved and your
            order will not be processed.
          </strong>
        </p>
        <p>
          <strong>
            Cart Total: <span className="pl4 text-green">${total}</span>
          </strong>
        </p>
      </div>
    );
  }

  render() {
    const { payLoading } = this.state;

    return (
      <div className="complete-pay">
        <Heading text="Review and Checkout" />

        <div className="content">
          <div className="inner">
            {this.renderCart()}
            <div id="dropin-container"></div>
            <div className="payment-action">
              <button
                id="payment-button"
                disabled={payLoading}
                onClick={this.handlePayment}
              >
                {payLoading ? 'Processing...' : 'Pay Now'}
              </button>
            </div>
          </div>
        </div>

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  team: state.teams.selectedTeam,
  members: state.users.members,
  clientToken: state.payment.clientToken,
  paymentStatus: state.payment.status,
  fields: state.create.fields,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  status: state.agreements.status,
  agreement: state.agreements.selectedAgreement,
  agreementContractBlocks: state.agreements.contractBlocks,
  deal: state.deals.selectedDeal,
  dealStatus: state.deals.status,
  work: state.works.selectedWork,
  workStatus: state.works.status,
  workOwnerships: state.workOwnerships.workOwnerships,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  pay: (options) => {
    dispatch(actions.pay(options));
  },
  createAgreement: (agreement) => {
    dispatch(actions.createAgreement(agreement));
  },
  createWork: (work) => {
    dispatch(actions.createWork(work));
  },
  resetCreateWork: () => {
    dispatch(actions.resetAttribute());
    dispatch(actions.resetContractBlockContents());
  },
  createDeal: (deal) => {
    dispatch(actions.createDeal(deal));
  },
  createInvite: (dealId, invite) => {
    dispatch(actions.createInvite(dealId, invite));
  },
  createWorkOwnership: (workOwnership) => {
    dispatch(actions.createWorkOwnership(workOwnership));
  },
  createDealUser: (dealUser) => {
    dispatch(actions.createDealUser(dealUser));
  },
  createPublisher: (publisher) => {
    dispatch(actions.createPublisher(publisher));
  },
  saveBlockContent: (block) => {
    dispatch(actions.saveAgreementContractBlockContent(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreementPayment);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementPayment.jsx